<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Ladninger - lige nu</h1>
  </div>
</div>
<div class="comp-main">
  <div class="dashboard-container">
    <!-- =========================
       MAP SECTION (Left)
       ========================= -->
    <section class="map-section">
      <div id="active-map" class="active-map"></div>
      <div class="map-overlay">
        <span class="overlay-text"> Aktive ladninger: {{ (activeChargingTransactions$ | async)?.length || 0 }} </span>
      </div>
    </section>

    <!-- ===================================
       FINISHED TRANSACTIONS (Right)
       =================================== -->
    <section class="tx-section">
      <h2 class="h5">Live ladninger</h2>

      @if (activeChargingTransactions$ | async; as finishedTxs) {
        <mat-accordion>
          @for (tx of finishedTxs; track tx.chargingToken) {
            <mat-expansion-panel (opened)="onFinishedOpened(tx)" (closed)="onFinishedClosed(tx)">
              <mat-expansion-panel-header>
                <div class="tx__item">
                  <div class="tx__logo">
                    @if (tx.organizationCompactLogo) {
                      <img [src]="tx.organizationCompactLogo" alt="{{ tx.organizationName }}" />
                    } @else {
                      <svg class="icon-32"><use href="assets/images/ok-icons-sprite.svg#building-m"></use></svg>
                    }
                  </div>
                  <div class="tx__org-info">
                    <span>{{ tx.organizationName }}</span>
                    <span>Lokation: {{ tx.locationName }}</span>
                    <span>Ladepunkt: {{ tx.stationNumber }}</span>
                  </div>
                  <div class="tx__stats">
                    <span>{{ tx.chargingStart | date: 'dd.MM.yyyy HH:mm' }}</span>
                    <span>
                      {{ consumptionToPrettyOutput(tx.consumption) }}
                    </span>
                    <span>{{ secondsToPrettyTime(tx.chargeTime) }}</span>
                  </div>
                </div>
              </mat-expansion-panel-header>

              <div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Organisation:</span>
                  <span>{{ tx.organizationName }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Afdeling:</span>
                  <span>{{ tx.departmentName }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Lokationsadresse:</span>
                  <span>{{ tx.road }} {{ tx.number }}, {{ tx.postalCode }} {{ tx.city }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Organisationstype:</span>
                  <span>{{ tx.organzationType }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Adgangsgruppe:</span>
                  <span>{{ tx.accessGroupName || '– Ingen –' }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Pris:</span>
                  <span>{{ tx.pricePerUnit | number: '1.2-2' }} kr/kWh</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Total ladetid:</span>
                  <span>{{ tx.chargeTime }} minutter</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Igangsat fra:</span>
                  <span>{{ tx.origin }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Betalingsmetode:</span>
                  <span>{{ tx.paymentMethod }}</span>
                </div>
                <div class="tx__detail-row">
                  <span class="tx__detail-label">Charging token:</span>
                  <span>{{ tx.chargingToken }}</span>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>

        @if (!finishedTxs.length) {
          <ok-feedback-info> Ingen igangværende ladninger fundet. </ok-feedback-info>
        }
      }
    </section>
  </div>
</div>
@if (selectedTransaction) {
  <div class="transaction-overlay" (click)="selectedTransaction = null">
    <div class="overlay-content" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="selectedTransaction = null">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
      </button>

      <div class="overlay-header">
        @if (selectedTransaction.organizationCompactLogo) {
          <div class="overlay-logo">
            @if (selectedTransaction.organizationCompactLogo) {
              <img [src]="selectedTransaction.organizationCompactLogo" alt="{{ selectedTransaction.organizationName }}" />
            } @else {
              <svg class="icon-64"><use href="assets/images/ok-icons-sprite.svg#building-l"></use></svg>
            }
          </div>
        }
        <div class="overlay-title">
          <div class="h4">{{ selectedTransaction.organizationName }}</div>
          <div>{{ selectedTransaction.locationName }}</div>
        </div>
      </div>

      <p><strong>Ladepunkt:</strong> {{ selectedTransaction.stationNumber }}</p>
      <p>
        <strong>Start:</strong>
        {{ selectedTransaction.created | date: 'dd.MM.yyyy HH:mm' }}
      </p>
      <p>
        <strong>Forbrug:</strong>
        @if (selectedTransaction.consumption === null) {
          Ikke tilgængelig
        } @else {
          {{ selectedTransaction.consumption | number: '1.0-0' }} kWh
        }
      </p>
      @if (selectedTransaction.liveDoc?.fireStoreDocLoaded) {
        @let liveDoc = selectedTransaction.liveDoc;
        <p><strong>Ladning i Wh:</strong> {{ liveDoc.chargeInWh }}</p>
        <p><strong>Effekt i W:</strong> {{ liveDoc.powerInW }}</p>
        <p>
          <strong>Total forbrug Wh:</strong>
          {{ liveDoc.totalConsumptionInWh }}
        </p>
        <p>
          <strong>Seneste opdatering:</strong>
          {{ liveDoc.powerUpdated | date: 'dd.MM.yyyy HH:mm:ss' }}
        </p>
        <div>Charging token:<br />{{ liveDoc.id }}</div>
      } @else {
        <ok-feedback-info>
          <p>
            Ladning med id : <strong>{{ selectedTransaction.liveDoc?.id }}</strong> er ikke fundet i firestore
          </p>
        </ok-feedback-info>
      }
    </div>
  </div>
}
